import TextareaAutosize from 'react-textarea-autosize';
import { Send } from 'lucide-react';

interface ReplyBoxProps {
  patientFirstName: string;
  message: string;
  onMessageChange: (value: string) => void;
  onSend: () => void;
  isSending: boolean;
}

export const ReplyBox = ({ patientFirstName, message, onMessageChange, onSend, isSending }: ReplyBoxProps) => {
  const canSend = !!message.trim() && !isSending;

  return (
    <div className="flex-shrink-0 border-t border-gray-100 px-6 pt-3 pb-4">
      <div className="rounded-xl px-4 pt-3 pb-2">
        <TextareaAutosize
          minRows={3}
          maxRows={8}
          value={message}
          onChange={(e) => onMessageChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); if (canSend) onSend(); }
          }}
          placeholder={`Message ${patientFirstName}...`}
          className="w-full resize-none text-sm text-secondary-800 placeholder:text-secondary-400 focus:outline-none bg-transparent"
        />
        <div className="flex items-center justify-end pt-2 mt-1 border-t border-gray-100">
          <button
            disabled={!canSend}
            onClick={onSend}
            className={`flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm font-semibold transition-colors ${
              canSend
                ? 'bg-teamcare-blue text-white hover:bg-teamcare-blue-dark'
                : 'bg-gray-100 text-secondary-400 cursor-not-allowed'
            }`}
          >
            {isSending ? 'Sending...' : <><Send size={14} /> Send</>}
          </button>
        </div>
      </div>
    </div>
  );
};
